import validate from "/builds/kampaay/scrum/node_modules/.pnpm/nuxt@3.14.159_@parcel+watcher@2.5.0_@types+node@18.19.64_ioredis@5.4.1_magicast@0.3.5_rollup@_p5ugzijmgl2a4yb6ff4niyfgw4/node_modules/nuxt/dist/pages/runtime/validate.js";
import auth_45global from "/builds/kampaay/scrum/middleware/auth.global.ts";
import manifest_45route_45rule from "/builds/kampaay/scrum/node_modules/.pnpm/nuxt@3.14.159_@parcel+watcher@2.5.0_@types+node@18.19.64_ioredis@5.4.1_magicast@0.3.5_rollup@_p5ugzijmgl2a4yb6ff4niyfgw4/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  auth_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {}